// MOXIE: fix flechas pegadas por :focus-within (base.css:2003) en PLP
document.addEventListener(
  'pointerleave',
  (event) => {
    if (event.pointerType !== 'mouse') return;
    const card = event.target;
    if (!(card instanceof Element) || card.tagName !== 'PRODUCT-CARD') return;
    const active = document.activeElement;
    if (active instanceof HTMLElement && card.contains(active)) active.blur();
  },
  true
);
